import { DatePipe } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { SiaDate } from '../interfaces/sia-date';

@Injectable({
  providedIn: 'root',
})
export class SiaDateService {
  private datepipe = inject(DatePipe);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  date2number(dateTime: Date): SiaDate | null {
    let dateStr: string | null = this.datepipe.transform(dateTime, 'yyyyMMdd');
    if (!dateStr) return null;
    let dateInt: number = parseInt(dateStr);
    let hourStr: string | null = this.datepipe.transform(dateTime, 'HHmmss');
    if (!hourStr) return null;
    let hourInt: number = parseInt(hourStr);
    return { date: dateInt, hour: hourInt };
  }
  date2string(dateTime: Date): string | null {
    let dateStr: string | null = this.datepipe.transform(
      dateTime,
      'dd/MM/yyyy',
    );
    return dateStr;
  }

  date2string2digitYear(dateTime: any): string | null {
    let dateStr: string | null = this.datepipe.transform(dateTime, 'dd/MM/yy');
    return dateStr;
  }

  formatDate(date: Date, format: string, endDateHour?: boolean): string | null {
    if (format) {
      return this.datepipe.transform(date, format);
    }
    return date.toLocaleString();
  }
  number2date(dateInt: number, hourInt?: number): Date {
    if (dateInt) {
      let dateStr = dateInt.toString();
      let year = parseInt(dateStr.slice(0, 4));
      let month = parseInt(dateStr.slice(4, 6)) - 1;
      let days = parseInt(dateStr.slice(6, 8));
      if (hourInt) {
        let hourStr = hourInt.toString();
        let hours = parseInt(hourStr.slice(0, 2));
        let minutes = parseInt(hourStr.slice(2, 4));
        let seconds = parseInt(hourStr.slice(4, 6));
        let date = new Date(
          year,
          month,
          days,
          hours,
          minutes,
          seconds,
          undefined,
        );
        return date;
      } else {
        let date = new Date(
          year,
          month,
          days,
          undefined,
          undefined,
          undefined,
          undefined,
        );
        return date;
      }
    }
    return new Date();
  }
  number2string(dateInt: number, hourInt?: number): string | null {
    if (dateInt) {
      let dateStr: string | null = dateInt.toString();
      let year = parseInt(dateStr.slice(0, 4));
      let month = parseInt(dateStr.slice(4, 6)) - 1;
      let days = parseInt(dateStr.slice(6, 8));
      if (hourInt) {
        let hourStr = hourInt.toString();
        let hours = parseInt(hourStr.slice(0, 2));
        let minutes = parseInt(hourStr.slice(2, 4));
        let seconds = parseInt(hourStr.slice(4, 6));
        let date = new Date(
          year,
          month,
          days,
          hours,
          minutes,
          seconds,
          undefined,
        );
        dateStr = this.datepipe.transform(date, 'dd/MM/yyyy HH:mm:ss');
        return dateStr;
      } else {
        let date = new Date(year, month, days);
        dateStr = this.datepipe.transform(date, 'dd/MM/yyyy');
        return dateStr;
      }
    }
    return null;
  }

  getTimeFromMinutes(minutes: number): string {
    if (!minutes) return '00:00 ore';
    var time = '';
    if (minutes >= 60) {
      var HH = Math.trunc(minutes / 60);
      // console.log('HH', HH);
      // console.log(minutes);
      var mm = minutes - HH * 60;
      time = time + ('0' + HH).slice(-2) + ':' + ('0' + mm).slice(-2) + ' ore';
    } else {
      time = time + '00' + ':' + ('0' + minutes).slice(-2) + ' ore';
    }
    return time;
  }

  getDayOfCurrentMonth(): number {
    var d = new Date();
    var res = d.getDate();
    return res;
  }

  getCurrentMonthName(): string {
    var monthNames = [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre',
    ];
    var month = new Date().getMonth();
    return monthNames[month];
  }
}
